import { isUserManagementConfigured } from "../user/user-management";
import { useUserStore } from "../user/user.store";

/**
 * Fetches the user permission ids. Two supported sources per app config:
 * - JWT-token clients carry `Perm` in the token - the auth store reads it
 *   there and never calls this.
 * - Reference-token clients (ShipBob.OneId.User, the MerchantApp client)
 *   get it from the user-management detailed-user response, loaded once into
 *   the user store. Requires `userManagementApiUrl` in appsettings AND the
 *   client_id present in the API UserReadDataPermissionList allowlist.
 * With neither source configured, permissions resolve empty (deny-all).
 */
export async function fetchUserPermissions(): Promise<string[]> {
  if (!isUserManagementConfigured()) {
    console.warn(
      "[Auth] Token has no Perm claim and no userManagementApiUrl is configured, permissions unavailable (deny-all).",
    );
    return [];
  }

  const userStore = useUserStore();
  await userStore.initializeUserContext();
  return userStore.permissions;
}
